import { HttpClient } from '../HttpClient';
/**
 * * Post Create Attendance Logs
 */
export const PostCreateAttendanceLogs = async (params) => {
  try {
    const { data } = await HttpClient.post(`api/attendanceLogs`, { ...params });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
